import { Injectable } from '@angular/core';
import {Router,CanActivate,ActivatedRouteSnapshot,RouterStateSnapshot} from '@angular/router';

@Injectable()
export class AuthguardService implements CanActivate {

  constructor(private router:Router) { }


  ngOnInit() {
    this.router.navigate(['/login']);
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    if (sessionStorage.getItem('currentUser')) {
        return true;
    }
    // not logged in so redirect to login page with the return url
  //  this.router.navigate(['/login'], { queryParams: { returnUrl: state.url }});
  //  return false;
  
  this.router.navigate(['/login']);
    return false;
  }
}



// WEBPACK FOOTER //
// D:/Sonali/JCCBViewOnlyProject/ViewOnlyJCCBfrontend19112022/InternetBanking6.3frontend/src/app/service/authguard.service.ts